var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('main',[_c('backoffice-header'),_c('router-view'),_c('backoffice-footer')],1):_vm._e(),_c('modal-notification',{ref:"notification"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }